import products from "@/api/products";

const getDefaultState = () => ({
  productNoteTypes: ["Billing", "Complaints", "Credit Control", "Inbound Call", "Migrations", "Onboarding", "Provisioning", "Retentions", "Sales", "Technical", "Websites"],
  productNotes: [],
  productNotesErr: false,
  productNotesLoading: true,

  isAddProductNoteLoading: false,
  isAddProductNoteError: false,
  addProductNoteErrorResponse: '',

  noteTemplates: null,
  isFetchNoteTemplatesLoading: false,
  isFetchNoteTemplatesError: false,
  isFetchNoteTempatesErrorResponse: false,
});

const state = getDefaultState();

const mutations = {
  PRODUCT_NOTES(state, payload) {
    state.productNotes = payload;
    state.productNotesLoading = false;
    state.productNotesErr = false;
  },
  PRODUCT_NOTES_ERR(state) {
    state.productNotesErr = true;
    state.productNotesLoading = false;
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  CREATE_PRODUCT_NOTE_BEGIN(state) {
    state.isAddProductNoteLoading = true;
    state.isAddProductNoteError = false;
    state.addProductNoteErrorResponse = null;
  },
  CREATE_PRODUCT_NOTE_SUCCESS(state) {
    state.isAddProductNoteLoading = false;
  },
  CREATE_PRODUCT_NOTE_ERROR(state, err) {
    state.isAddProductNoteLoading = false;
    state.isAddProductNoteError = true;
    state.addProductNoteErrorResponse = err;
  },

  FETCH_NOTE_TEMPLATES_BEGIN(state) {
    state.isFetchNoteTemplatesLoading = true;
    state.isFetchNoteTemplatesError = false;
    state.isFetchNoteTempatesErrorResponse = false;
  },
  FETCH_NOTE_TEMPLATES_SUCCESS(state, payload) {
    state.noteTemplates = payload;
    state.isFetchNoteTemplatesLoading = false;
  },
  FETCH_NOTE_TEMPLATES_ERROR(state, error) {
    state.isFetchNoteTemplatesLoading = false;
    state.isFetchNoteTemplatesError = true;
    state.isFetchNoteTempatesErrorResponse = error;
  },
}

const actions = {
  async loadProductNotes({ commit }, id) {
    try {
      const response = await products.loadProductNotes(id);
      commit("PRODUCT_NOTES", response.data);
    } catch (e) {
      commit("PRODUCT_NOTES_ERR");
    }
  },

  async createProductNote({ commit, dispatch }, { id, data }) {
    commit('CREATE_PRODUCT_NOTE_BEGIN');
    try {
      await products.createProductNote(id, data);
      commit('CREATE_PRODUCT_NOTE_SUCCESS');
      dispatch("loadProductNotes", id);
      dispatch("alerts/setAlert", { type: "success", message: `Note added successfully`,}, { root: true });
    } catch(err) {
      commit('CREATE_PRODUCT_NOTE_ERROR', err.response.data);
      dispatch("alerts/setAlert", {
        type: "error",
        message: `There has been an error: ${err.response.data.message ? err.response.data.message : err}`,
      }, { root: true });
    }
  },

  async fetchNoteTemplates({ commit }) {
    commit("FETCH_NOTE_TEMPLATES_BEGIN");
    try {
      const response = await products.fetchNoteTemplates();
      commit("FETCH_NOTE_TEMPLATES_SUCCESS", response.data);
    } catch(err) {
      commit("FETCH_NOTE_TEMPLATES_ERROR", err);
    }
  },

  resetState({ commit }) {
    commit("RESET_STATE");
  }
}

const getters = {
  getProductNotesTypes: (state) => state.productNoteTypes,
  getProductNotes: (state) => state.productNotes,
  getProductNotesErr: (state) => state.productNotesErr,
  getProductNotesLoading: (state) => state.productNotesLoading,
  getAddProductNoteLoading: (state) => state.isAddProductNoteLoading,
  getAddProductNoteError: (state) => state.isAddProductNoteError,

  getNoteTemplates: state => state.noteTemplates,
  getIsFetchNoteTemplatesLoading: state => state.isFetchNoteTemplatesLoading,
  getIsFetchNoteTemplatesError: state => state.isFetchNoteTemplatesError,
  getIsFetchNoteTempatesErrorResponse: state => state.isFetchNoteTempatesErrorResponse,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};